import { string, object } from "yup";
import moment from "moment";

const stringSchema = string()
  .trim()
  .lowercase()
  .nullable()
  .typeError("Поле может содержать только буквенное значение");
const numberRegEx = /^[0-9]+$/gi;

const numberSchema = string().matches(numberRegEx, "Только число").nullable();

const validationCandidate = {
  surname: stringSchema,
  name: stringSchema,
  patronymic: stringSchema,
  phone: string()
    .typeError("Должно быть числом")
    .matches(/^[0-9]{11,12}$/, "Формат номера телефона не корректный")
    .nullable(),
  email: string().email("Введите корректный email").nullable(),
  birthday: string()
    .required("Введите дату рождения")
    .test(
      "birthday",
      "Кандидатом может быть человек, достигший 19 лет и не старше 70",
      (value) => {
        return (
          moment().diff(moment(value), "years") >= 19 &&
          moment().diff(moment(value), "years") <= 70
        );
      }
    ),
  non_resident: stringSchema,
  birth_place: stringSchema,
  region_of_residence: stringSchema,
  registration: stringSchema,
  migration_card_number: stringSchema,
  departure_country: stringSchema,
  visa_number: stringSchema,
  visit_goal: stringSchema,
  inviting_information: stringSchema,
  date_visit_start: numberSchema,
  date_visit_expired: numberSchema,

  hasConviction: string(),
  conviction: string()
    .nullable()
    .when("hasConviction", {
      is: "Есть",
      then: string().nullable().required("Заполните информацию")
    }),

  passport_propiska: stringSchema
};

export const getValidationSchema = (cols, requiredCols) => {
  const validationSchema = {};

  cols.map((col) => {
    validationSchema[col] = validationCandidate[col]
      ? validationCandidate[col]
      : string().nullable();

    if (requiredCols?.includes(col))
      validationSchema[col] = validationSchema[col]?.required(
        "Поле обязательно для заполнения"
      );
  });

  return object(validationSchema);
};
